
import { createRouter, createWebHistory } from "vue-router";
const Home = () => import("../views/Home.vue");
const Login = () => import("@/modules/authorization/components/Login.vue");
const SignUp = () => import("@/modules/authorization/components/SignUp.vue");
const ForgetPassword = () => import("@/modules/authorization/components/ForgetPassword.vue");
const MaintenanceComponent = () => import("@/shared/components/maintenance/Maintainence.vue");
import AccountRoutes from "@/modules/account";
import WalletRoutes from "@/modules/wallet";
import GamesRoutes from "@/modules/games";
import SportsRoutes from "@/modules/sports";
import ReferEarnRoutes from "@/modules/refer-earn";
import ProfileRoutes from "@/modules/profile";
import BetsRoutes from "@/modules/bets";
import MatkaRoutes from "@/modules/matka";
import BonusRoutes from "@/modules/bonus";
import CricketFightRoutes from "@/modules/cricket-fight";
import NotificationsRoutes from "@/modules/notification";
import Faq from "../shared/components/faq/Faq.vue";
import NotFound from "../shared/components/no-data/404.vue";
import AffiliateRoutes from '@/modules/affiliate';
import SpinRoutes from '@/modules/SpinWheel';
import TwoFARoutes from '@/modules/2FA';

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/login",
        name: "login",
        component: Login
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: SignUp
      },
      {
        path: "/forget-password",
        name: "forget-password",
        component: ForgetPassword
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: MaintenanceComponent
      },
      {
        path: "/faq",
        name: "Faq",
        component: Faq
    },
    AccountRoutes,
    WalletRoutes,
    GamesRoutes,
    SportsRoutes,
    ReferEarnRoutes,
    ProfileRoutes,
    BetsRoutes,
    MatkaRoutes,
    BonusRoutes,
    CricketFightRoutes,
    NotificationsRoutes,
    AffiliateRoutes,
    SpinRoutes,
	  TwoFARoutes,
    { 
      path: '/:pathMatch(.*)*',
      name: 'NotFound', 
      component: NotFound 
    },  
];

export default createRouter({
    history: createWebHistory(),
    routes
});

